import { useQuery } from 'react-query';

import { axios } from 'lib';

const getRateSuppliers = (frameworkAgreementId, lotId) => {
  return axios.get(
    `/api/framework_agreements/${frameworkAgreementId}/setup/lots/${lotId}/rates/suppliers`
  );
};

export const useRateSuppliers = (frameworkAgreementId, lotId, options = {}) => {
  return useQuery(
    `framework_agreements-${frameworkAgreementId}-setup-lots-${lotId}-rate-suppliers`,
    () => getRateSuppliers(frameworkAgreementId, lotId),
    {
      //@ts-ignore
      initialData: { data: { data: [] } },
      select: ({ data }) => data.data,
      ...options,
    }
  );
};
